/*
 * Regalo gratis nativo (reemplaza la app AOV.ai Free Gift & BXGY).
 *
 * - "Reclamar" añade el producto regalo (0 €) al carrito y refresca el drawer.
 * - Guard: si el carrito deja de cualificar (se quita el producto que da derecho
 *   al regalo) y el regalo sigue dentro, se retira automáticamente.
 *
 * La visibilidad del bloque la decide Liquid (snippets/gift-reward.liquid); este
 * script solo gestiona acciones de carrito y dispara `cart:update` para que el
 * cart-items-component de Horizon vuelva a renderizar la sección desde el servidor.
 *
 * Se carga UNA vez y de forma incondicional desde snippets/cart-drawer.liquid
 * (no dentro del bloque condicional, porque un <script> reinyectado por morph no
 * se ejecuta). Usa listeners delegados en document, así que captura el botón
 * "Reclamar" aparezca cuando aparezca.
 */
(function () {
  if (window.__giftRewardInit) return;
  window.__giftRewardInit = true;

  var GIFT_VARIANT_ID = 46441881141498;
  var TRIGGER_PRODUCT_IDS = [8622392606970, 8608596754682, 8617145860346, 8712195571962];
  // Guía del bien vestir [PDF]: regalo de la app de bundles (AOV.ai). La app crea
  // una línea NUEVA por cada bundle que la regala (propiedades _aov_bundles/_atclid
  // distintas, Shopify no las fusiona) -> con dos bundles salen dos guías. El guard
  // de abajo elimina las sobrantes y deja una sola.
  var GUIDE_VARIANT_ID = 46814863851770;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;
  // cart:update que llega mientras busy=true (p. ej. los que disparan nuestras
  // propias mutaciones en cadena) NO se puede descartar sin más: la reconciliación
  // de la guía hace return sin evaluar el llavero, y sin re-pasada el llavero
  // queda huérfano para siempre (bug 09/07). Se apunta y se re-ejecuta al liberar.
  var pendingReconcile = false;
  // Tope de re-pasadas consecutivas: si una mutación falla en bucle (p. ej. 422
  // persistente) no queremos martillear cart.js. Se resetea con actividad externa.
  var pendingReruns = 0;

  function releaseBusy() {
    busy = false;
    if (pendingReconcile && pendingReruns < 3) {
      pendingReconcile = false;
      pendingReruns++;
      reconcileCart();
    } else {
      pendingReconcile = false;
    }
  }

  function getCartSectionId() {
    var comp = document.querySelector('cart-items-component[data-section-id]');
    return comp ? comp.getAttribute('data-section-id') : null;
  }

  // Operación de carrito que pide las secciones renderizadas y dispara cart:update
  // CON esas secciones -> Horizon hace MORPH (no re-render completo), así el cart
  // drawer NO se cierra ni la página queda con el scroll bloqueado.
  function cartMutate(url, body) {
    var sectionId = getCartSectionId();
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT + url, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        // GOTCHA Horizon: CartAddEvent.eventName === ThemeEvents.cartUpdate, o sea
        // 'cart:add' y 'cart:update' son EL MISMO evento. CartDrawerComponent hace
        // showDialog() en cada 'cart:update' si tiene auto-open -> nuestras
        // mutaciones silenciosas (retirar llavero/guía) ABRÍAN el drawer solos.
        // dispatchEvent es síncrono: quitamos auto-open solo durante el dispatch.
        var drawer = document.querySelector('cart-drawer-component');
        var hadAutoOpen = drawer && drawer.hasAttribute('auto-open');
        if (hadAutoOpen) drawer.removeAttribute('auto-open');
        try {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { sections: (res && res.sections) || null, source: 'gift-reward' } },
            })
          );
        } finally {
          if (hadAutoOpen) drawer.setAttribute('auto-open', '');
        }
        return res;
      });
  }

  // Tras re-renderizar el carrito, el <dialog> del drawer puede quedar abierto pero
  // SIN estado modal: se ve comprimido/diminuto arriba con la página detrás (sin el
  // fondo oscuro). Lo detectamos con :modal y, si pasó, lo reabrimos como modal para
  // restaurar su tamaño de pantalla completa. SOLO repara ese estado: si el dialog
  // está cerrado NO lo abre (abrirlo aquí hacía que el drawer se abriera solo al
  // cargar la página cuando la reconciliación limpiaba el carrito — bug 09/07).
  function ensureModalDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    var dialog = drawer && drawer.querySelector('dialog.cart-drawer__dialog');
    if (!drawer || !dialog) return;
    var isModal = false;
    try {
      isModal = dialog.matches(':modal');
    } catch (e) {}
    if (!dialog.open || isModal) return; // cerrado o ya modal: no tocar
    try {
      dialog.close();
    } catch (e) {}
    try {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof dialog.showModal === 'function') dialog.showModal();
    } catch (e) {}
  }

  function scheduleEnsureModalDrawer() {
    requestAnimationFrame(ensureModalDrawer);
    setTimeout(ensureModalDrawer, 150);
  }

  // "Reclamar" → añade el regalo (0 €) y refresca el drawer.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-gift-claim]');
    if (!button || busy) return;

    event.preventDefault();
    busy = true;
    button.setAttribute('disabled', '');

    cartMutate('cart/add.js', {
      items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _regalo: 'Sí' } }],
    })
      .then(function () {
        releaseBusy();
        scheduleEnsureModalDrawer();
      })
      .catch(function (error) {
        console.error('[gift-reward] No se pudo añadir el regalo:', error);
        button.removeAttribute('disabled');
        releaseBusy();
      });
  });

  // Mueve la línea del regalo al FINAL del carrito (Shopify la añade arriba por ser
  // lo último). Las operaciones de línea usan item.index (posición real), no la
  // visual, así que mover el <tr> en el DOM es seguro.
  function moveGiftLast() {
    var rows = document.querySelectorAll('tr[data-key^="' + GIFT_VARIANT_ID + ':"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var tbody = row.parentNode;
      if (tbody && tbody.lastElementChild !== row) {
        tbody.appendChild(row);
      }
    }
  }

  // Inyecta (una vez) los estilos de la línea del regalo en el carrito:
  // oculta el selector de cantidad y el botón de eliminar, y estiliza la etiqueta.
  function injectGiftLineStyles() {
    if (document.getElementById('gift-line-styles')) return;
    var s = document.createElement('style');
    s.id = 'gift-line-styles';
    s.textContent =
      '.cart-items__table-row.is-gift-line .quantity-selector,' +
      '.cart-items__table-row.is-gift-line .cart-items__remove{display:none!important;}' +
      '.cart-gift-tag{display:inline-block;font-size:11px;font-weight:600;letter-spacing:.02em;' +
      'color:#707070;background:#f0f0f0;border-radius:4px;padding:3px 8px;white-space:nowrap;}';
    document.head.appendChild(s);
  }

  // Marca la línea del regalo: clase para bloquear la cantidad + etiqueta "Regalo".
  function decorateGiftLine() {
    var rows = document.querySelectorAll('tr[data-key^="' + GIFT_VARIANT_ID + ':"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.classList.add('is-gift-line');
      var qtyCell = row.querySelector('.cart-items__quantity');
      if (qtyCell && !qtyCell.querySelector('.cart-gift-tag')) {
        var tag = document.createElement('span');
        tag.className = 'cart-gift-tag';
        tag.textContent = 'Regalo';
        qtyCell.appendChild(tag);
      }
    }
  }

  // El drawer re-renderiza de forma asíncrona (sectionRenderer); un observer
  // reposiciona el regalo en cuanto aparecen/cambian las filas. El check de
  // "ya es el último" evita bucles y lo hace un no-op cuando está colocado.
  function applyGiftDecor() {
    moveGiftLast();
    decorateGiftLine();
  }

  var giftObserver = new MutationObserver(applyGiftDecor);

  function startObserving() {
    injectGiftLineStyles();
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) {
      giftObserver.observe(comps[i], { childList: true, subtree: true });
    }
    applyGiftDecor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // Guard: retira el regalo si el carrito ya no cualifica, y reconcilia la guía
  // de la app de bundles. Corre en cada cart:update y una vez al cargar la página
  // (para limpiar carritos que ya vengan mal de una sesión anterior).
  function reconcileCart() {
    if (busy) {
      pendingReconcile = true;
      return;
    }

    fetch(ROOT + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // 1) Guía del bien vestir (regalo de la app de bundles AOV.ai). La app crea
        //    una línea nueva por cada bundle (props _aov_bundles/_atclid únicas, no
        //    fusionan) y NUNCA la limpia: al quitar el bundle que la regaló, la guía
        //    se queda en el carrito DE PAGO. Regla: como mucho UNA guía y SIEMPRE
        //    gratis. Si hay alguna gratis, conservar la más antigua y quitar el
        //    resto. Si solo quedan de pago (huérfanas), re-vincular la más antigua
        //    al primer bundle del carrito que la vuelva gratis (reescribir su
        //    _aov_bundles re-evalúa el descuento server-side; verificado); si
        //    ningún bundle la vuelve gratis, retirarla. Solo toca líneas creadas
        //    por la app (con _aov_bundles): una guía comprada a propósito desde su
        //    PDP no lleva esa propiedad y no se toca.
        //    Mutaciones SIEMPRE vía cartMutate (morph con secciones): un cart:update
        //    sin secciones re-renderizaría el drawer y lo dejaría comprimido.
        var guides = cart.items.filter(function (i) {
          return i.variant_id === GUIDE_VARIANT_ID && i.properties && i.properties._aov_bundles;
        });
        if (guides.length) {
          var freeGuides = guides.filter(function (g) {
            return g.final_price === 0;
          });
          var chain = null;

          if (freeGuides.length) {
            // Conservar la gratis más antigua (cart.js lista lo nuevo primero);
            // quitar duplicadas y cualquier huérfana de pago.
            var keep = freeGuides[freeGuides.length - 1];
            var extras = guides.filter(function (g) {
              return g.key !== keep.key;
            });
            if (extras.length) {
              chain = Promise.resolve();
              extras.forEach(function (extra) {
                chain = chain.then(function () {
                  return cartMutate('cart/change.js', { id: extra.key, quantity: 0 });
                });
              });
            }
          } else {
            // Todas de pago: quitar las sobrantes y re-vincular la más antigua a un
            // bundle superviviente (línea con _aov_bundles y qty >= 3, que es el
            // escalón que regala la guía). Se prueba cada offer y se comprueba el
            // precio en la respuesta; si ninguno la vuelve gratis, se retira.
            var orphan = guides[guides.length - 1];
            var candidates = [];
            var seenOffers = {};
            cart.items.forEach(function (i) {
              if (i.variant_id === GUIDE_VARIANT_ID || i.quantity < 3) return;
              if (!i.properties || !i.properties._aov_bundles) return;
              try {
                var offerId = JSON.parse(i.properties._aov_bundles).offerId;
                if (offerId && !seenOffers[offerId]) {
                  seenOffers[offerId] = true;
                  candidates.push({ offerId: offerId, productId: i.product_id });
                }
              } catch (e) {}
            });

            chain = Promise.resolve();
            guides.slice(0, guides.length - 1).forEach(function (extra) {
              chain = chain.then(function () {
                return cartMutate('cart/change.js', { id: extra.key, quantity: 0 });
              });
            });
            chain = chain.then(function () {
              var key = orphan.key;
              var props = orphan.properties;
              var attempt = Promise.resolve(false);
              candidates.forEach(function (cand) {
                attempt = attempt.then(function (done) {
                  if (done) return true;
                  var newProps = {};
                  for (var k in props) newProps[k] = props[k];
                  newProps._aov_bundles = JSON.stringify({
                    offerId: cand.offerId,
                    giftFromId: String(cand.productId),
                  });
                  // Reescribir propiedades cambia la key de la línea: seguirla
                  // desde la respuesta para el siguiente intento o la retirada.
                  return cartMutate('cart/change.js', { id: key, quantity: 1, properties: newProps }).then(
                    function (res) {
                      var line = ((res && res.items) || []).filter(function (i) {
                        return i.variant_id === GUIDE_VARIANT_ID && i.properties && i.properties._aov_bundles;
                      })[0];
                      if (!line) return true;
                      key = line.key;
                      props = line.properties;
                      return line.final_price === 0;
                    }
                  );
                });
              });
              return attempt.then(function (done) {
                if (done) return;
                return cartMutate('cart/change.js', { id: key, quantity: 0 });
              });
            });
          }

          if (chain) {
            busy = true;
            chain
              .then(function () {
                // releaseBusy re-ejecuta reconcileCart si llegó un cart:update
                // durante la cadena (siempre llega: cartMutate lo dispara), así
                // la fase 2 (llavero) SÍ se evalúa tras limpiar la guía.
                releaseBusy();
                scheduleEnsureModalDrawer();
              })
              .catch(function (error) {
                console.error('[gift-reward] No se pudo reconciliar la guía:', error);
                releaseBusy();
              });
            return;
          }
        }

        // 2) Llavero (regalo nativo): forzar EXACTAMENTE una unidad en una sola
        //    línea cuando el carrito cualifica, y 0 cuando no. Cierra el abuso
        //    multi-llavero (permalink /cart/add?quantity=N, doble-clic en Reclamar,
        //    stepper del regalo manipulado). Es un no-op en el caso normal
        //    (1 línea, qty 1): no muta nada, mismo comportamiento que antes.
        var gifts = cart.items.filter(function (i) {
          return i.variant_id === GIFT_VARIANT_ID;
        });
        if (!gifts.length) return;

        var hasTrigger = cart.items.some(function (i) {
          return TRIGGER_PRODUCT_IDS.indexOf(i.product_id) !== -1;
        });

        var giftChain = null;
        if (!hasTrigger) {
          // No cualifica: retirar TODAS las líneas de regalo.
          giftChain = Promise.resolve();
          gifts.forEach(function (g) {
            giftChain = giftChain.then(function () {
              return cartMutate('cart/change.js', { id: g.key, quantity: 0 });
            });
          });
        } else if (gifts.length > 1 || gifts[0].quantity > 1) {
          // Cualifica pero hay de más: conservar UNA línea (preferir la creada por
          // "Reclamar", con _regalo; si no, la más antigua) a qty 1 y quitar el resto.
          var keep = null;
          for (var gi = gifts.length - 1; gi >= 0; gi--) {
            if (gifts[gi].properties && gifts[gi].properties._regalo) {
              keep = gifts[gi];
              break;
            }
          }
          if (!keep) keep = gifts[gifts.length - 1];

          giftChain = Promise.resolve();
          gifts.forEach(function (g) {
            if (g.key === keep.key) return;
            giftChain = giftChain.then(function () {
              return cartMutate('cart/change.js', { id: g.key, quantity: 0 });
            });
          });
          if (keep.quantity !== 1) {
            giftChain = giftChain.then(function () {
              return cartMutate('cart/change.js', { id: keep.key, quantity: 1 });
            });
          }
        }

        if (!giftChain) return; // caso normal: nada que hacer

        busy = true;
        giftChain
          .then(function () {
            releaseBusy();
            scheduleEnsureModalDrawer();
          })
          .catch(function (error) {
            console.error('[gift-reward] No se pudo normalizar el regalo:', error);
            releaseBusy();
          });
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', function () {
    // Actividad nueva (no nuestra cadena): resetea el tope de re-pasadas.
    if (!busy) pendingReruns = 0;
    reconcileCart();
  });
  // Pasada inicial: limpia guías huérfanas/duplicadas que vengan de una sesión previa.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileCart);
  } else {
    reconcileCart();
  }
})();
